module["exports"] = [
  "Afganistan",
  "Albanija",
  "Alžir",
  "Američka Samoa",
  "Andora",
  "Angola",
  "Anguila",
  "Antarktika",
  "Antigua i Barbuda",
  "Argentina",
  "Armenija",
  "Aruba",
  "Australija",
  "Austrija",
  "Azerbajdžan",
  "Bahami",
  "Bahrein",
  "Bangladeš",
  "Barbados",
  "Bjelorusija",
  "Belgija",
  "Belize",
  "Benin",
  "Bermuda",
  "Butan",
  "Bolivija",
  "Bonaire",
  "Bosna i Hercegovina",
  "Bocvana",
  "Otok Bouvet",
  "Brazil",
  "Bruneji",
  "Bugarska",
  "Burikina Faso",
  "Burundi",
  "Kambodža",
  "Kameron",
  "Kanada",
  "Zelenortska Republika",
  "Kajmanski Otoci",
  "Srednjoafrička Republika",
  "Čad",
  "Čile",
  "Kina",
  "Božićni Otoci",
  "Keeling Otoci",
  "Kolumbija",
  "Komori",
  "Kongo",
  "Demokratska Republika Kongo",
  "Cookovi Otoci",
  "Kostarika",
  "Hrvatska",
  "Kuba",
  "Curacao",
  "Cipar",
  "Češka",
  "Obala Bjelokosti",
  "Danska",
  "Džibuti",
  "Dominika",
  "Dominikanska Republika",
  "Ekvador",
  "Egipat",
  "Salvador",
  "Ekvatorijalna Gvineja",
  "Eritreja",
  "Estonija",
  "Etiopija",
  "Falkandski Otoci",
  "Farski Otoci",
  "Fidži",
  "Finska",
  "Francuska",
  "Francuska Gvajana",
  "Francuska Polinezija",
  "Južni Francuski Teritoriji",
  "Gabon",
  "Gambija",
  "Gruzija",
  "Njemačka",
  "Gana",
  "Gibraltar",
  "Grčka",
  "Grenland",
  "Grenada",
  "Guadelupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Gvineja",
  "Gvineja Bisau",
  "Gvajana",
  "Haiti",
  "Otok Heard i McDonald Otoci",
  "Vatikan",
  "Honduras",
  "Hong Kong",
  "Mađarska",
  "Island",
  "Indija",
  "Indonezija",
  "Iran",
  "Irak",
  "Irska",
  "Isle of Man",
  "Izrael",
  "Italija",
  "Jamajka",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazahstan",
  "Kenija",
  "Kiribati",
  "DNR Koreja",
  "Rebublika Koreja",
  "Kuvajt",
  "Krigistan",
  "Laos",
  "Latvija",
  "Libanon",
  "Lesoto",
  "Liberija",
  "Libija",
  "Lihtenštajn",
  "Litva",
  "Luksmburg",
  "Makao",
  "Makedonija",
  "Madagaskar",
  "Malavi",
  "Malezija",
  "Maldivi",
  "Mali",
  "Malta",
  "Maršalovi",
  "Martinik",
  "Mauritanija",
  "Mauricius",
  "Mayotte",
  "Meksiko",
  "Mikronezija",
  "Moldavija",
  "Monako",
  "Mongolija",
  "Crna Gora",
  "Monteserat",
  "Maroko",
  "Mozambik",
  "Mjanmar",
  "Namibija",
  "Nauru",
  "Nepal",
  "Nizozemska",
  "Nova Kaledonija",
  "Novi Zeland",
  "Nikaragva",
  "Niger",
  "Nigerija",
  "Niue",
  "Norfolk",
  "Sjeverni Marijanski Otoci",
  "Norveška",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestina",
  "Panama",
  "Papua Nova Gvineja",
  "Paragvaj",
  "Peur",
  "Filipini",
  "Pitcairn",
  "Poljska",
  "Protugal",
  "Portoriko",
  "Katar",
  "Rumunjska",
  "Ruska Federacija",
  "Ruanda",
  "Reunion",
  "Sveti Bartolomej",
  "Sveta Helena",
  "Sveti Kitts i Nevis",
  "Sveta Lucija",
  "Sveti Martin (fr.dio)",
  "Sveti Petar i Miquelon",
  "Sveti Vincent i Grenadini",
  "Samoa",
  "San Marino",
  "Sveti Toma i Princip",
  "Saudijska Arabija",
  "Senegal",
  "Srbija",
  "Sejšeli",
  "Siera Leone",
  "Singapur",
  "Sveti Martin (niz.dio)",
  "Slovačka",
  "Slovenija",
  "Salomoski Otoci",
  "Somalija",
  "Južna Afrika",
  "Južna Georgia i južni Sandwich",
  "Južni Sudan",
  "Španjolska",
  "Šri Lanka",
  "Sudan",
  "Surinam",
  "Svalvard i Jan Mayen",
  "Swaziland",
  "Švedska",
  "Švicarska",
  "Sirija",
  "Tajvan",
  "Tadžikistan",
  "Tanaznija",
  "Tajland",
  "Istočni Timor",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad i Tobago",
  "Tunis",
  "Turska",
  "Turkmenistan",
  "Otoci Turks i Caicos",
  "Tuvalu",
  "Uganda",
  "Ukrajina",
  "Ujedinjeni Arapski Emirati ",
  "Ujedinjeno Kraljevstvo",
  "Sjedinjenje Američke Države",
  "Urugvaj",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Britanski Djevičanski Otoci",
  "Američki Djevičanski Otoci",
  "Wallis i Futuna",
  "Zapadna Sahara",
  "Jemen",
  "Zambija",
  "Zimbabve"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/hr/address/country.js
// module id = 3076
// module chunks = 1609